export const environment = {
    production: false,
    apiUrl: 'https://dev.onetankdashboard.com',
    //apiUrl: 'http://localhost:5401',
    azureMapsKey: '8Jxvnf2MGWjYEbfKEmLwljSbPBSmBm8ZabZnKHKMQlE83eRk4GSIJQQJ99BIACYeBjFwp1p0AAAgAZMP321I',
    storageBaseUrl: 'https://onetankstorage.blob.core.windows.net/customer-logos'
};
